import { gql } from 'apollo-boost';

export const SEND_EMAIL_WITH_RESERVATIONS = gql`
  mutation {
    sendEmailWithReservations
  }
`;
